import React from 'react';
import './NewOrder.css';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api,image_api } from "../constant";
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../NewHeader/Layout';
// import cimage from '../../../images/burger/b3.png';
import { Doughnut } from 'react-chartjs-2';
import { FaDownload } from 'react-icons/fa';
import { Form, InputGroup,Dropdown,DropdownButton } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { Row } from 'reactstrap';
import DefaultProfileImage from '../../images/profile.png';
import Pagination from 'react-js-pagination';
import jsPDF from "jspdf";
import "jspdf-autotable"; // Optional, for handling table styling and auto table creation
import * as XLSX from "xlsx";
import Table from 'react-bootstrap/Table';
import profile from '../../images/splash/avatar.png';
import Loader from '../Loader/Loader';

const NewOrder = () => {
  const history = useHistory();
  const [show, setShow]  = useState(false);
  const [tables, setTables] = useState([]);
  const [shops, setShops] = useState([]);
  const [selectedShop, setSelectedShop] = useState(null);
  const [ searchQuery,setSearchQuery] = useState('');
  const [selectedItemCode, setSelectedItemCode] = useState(null);
  const [ isEdit,setIsEdit ] = useState(false);
  const [bookingOrder, setBookingorders] = useState([]);
  const [ itempopup, setItempopup ] = useState(false);
  const [ orderNo, setOrderNo ] = useState('');
  const [ updateId, setupdateId ] = useState('');
  const [ orderedItems, setorderItems ] = useState([]);
  const [ setOrdereditempopup, setOrderedItempopup ] = useState(false);
  const [ currentOrder, setCurrentOrder ] = useState(false);
  

  const [ loading, setLoading ] = useState(false);

  const [formData, setFormData] = useState({
    e_name: "", 
    e_email: null, 
    e_password: null,
    e_phone: null,
    e_role: "",
    profile: null,
    shops: [],
    user_id: localStorage.getItem("userId")
});

const getFirstDayOfCurrentMonth = () => {
  const date = new Date();
  date.setDate(1); // Set the day to 1st to get the first day of the current month
  return date;
};
const [startDate, setStartDate] = useState(getFirstDayOfCurrentMonth());  // Set to the first day of the current month
const [endDate, setEndDate] = useState(new Date());
console.log(formData)
  // Format the date in DD-MM-YYYY format
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = ("0" + date.getDate()).slice(-2);  // Add leading zero to day
    const month = ("0" + (date.getMonth() + 1)).slice(-2);  // Add leading zero to month
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;  // Return in DD-MM-YYYY format
  };


useEffect(() => {
  // Format dates before passing to API
  const formattedStartDate = formatDate(startDate);
  const formattedEndDate = formatDate(endDate);
  fetchTables(formattedStartDate, formattedEndDate);
}, [startDate, endDate]);  // Re-run the API call whenever startDate or endDate changes


const fetchTables = async (selectedStartDate, selectedEndDate) => {
  setLoading(true);
  const shop_id = localStorage.getItem('ShopId');
  const token = localStorage.getItem('Token');

  try {
    const response = await axios.get(
      `${var_api}booking-orders/cancelled-order-report/${shop_id}/${selectedStartDate}/${selectedEndDate}`,
      {
        headers: {
          Authorization: `${token}`, // Add the token to the Authorization header dynamically
        },
      }
    );
    setLoading(false);
    console.log("Response received:", response);
    const user = response.data.data;
    setTables(user);
  } catch (error) {
    setLoading(false);
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('Token'); // Clear the invalid token
      history.push('/')// Redirect to the Sign-In page
    } else {
      console.error("Error fetching data:", error);
    }
  }
};
const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage] = useState(10); // Number of items per page
const [searchTerm, setSearchTerm] = useState('');

// Filtering tables based on search term
const filteredTables = tables.filter((item) => {
  const orderType = item.order_type === 1 ? "Normal Order" : item.order_type === 2 ? "Credit Order"  : "-";
  const payment = item.payment_status === 1 ? "Paid"  : "Not Paid";
  const refund = item.is_refund === 1 ? "Refunded"  : "Not Refunded";
  return (
    item.customer_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(item.mobile_no || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.order_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.delivery_address?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(item.amount || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(item.delivered_address || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.reject_remarks?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(item.booking_dates[0]?.date || "").toLowerCase().includes(searchTerm.toLowerCase()) || 
    String(item.rejected_date || "").toLowerCase().includes(searchTerm.toLowerCase()) || 
    orderType.toLowerCase().includes(searchTerm.toLowerCase()) ||
    refund.toLowerCase().includes(searchTerm.toLowerCase()) ||
    payment.toLowerCase().includes(searchTerm.toLowerCase()) 
  );
});

// Pagination logic
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentItems = filteredTables.slice(indexOfFirstItem, indexOfLastItem);
const totalItems = filteredTables.length;

const handleSearchInput = (event) => {
  setSearchTerm(event.target.value);
  setCurrentPage(1); // Reset to the first page when search changes
};

const handlePageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
};
const downloadReport = () => {
  // Create a new jsPDF instance
  const doc = new jsPDF();

  // Select the table element
  const table = document.querySelector("table");

  // Add the table to the PDF document with custom options
  doc.autoTable({
    html: table,
    startY: 10,  // Adjust starting position of the table
    styles: {
      fontSize: 7,  // Smaller font size for compact table
      cellPadding: 1,  // Less padding between cells
      valign: 'middle',  // Vertical alignment of text
    },
    columnStyles: {
      // Adjust column widths (example for all columns, change as needed)
      0: { cellWidth: 10 },
      1: { cellWidth: 10 },
      2: { cellWidth: 10 },
      3: { cellWidth: 10 },
      4: { cellWidth: 10 },
      5: { cellWidth: 10 },
      6: { cellWidth: 10 },
      7: { cellWidth: 10 },
      8: { cellWidth: 10 },
      9: { cellWidth: 10 },
      10: { cellWidth: 10 },
    },
    margin: { top: 20 }, // Adjust margin if needed
  });

  // Save the PDF document with a filename
  doc.save("CancelledOrderReport.pdf");
};
const downloadExcel = () => {
  // Select the table element
  const table = document.querySelector("table");

  // Convert the table to a worksheet
  const worksheet = XLSX.utils.table_to_sheet(table);

  // Create a new workbook and append the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

  // Write the workbook and trigger a download
  XLSX.writeFile(workbook, "CancelledOrderReport.xlsx");
};

const handleshow =(data,dataId)=>{
  setBookingorders(data);
  setItempopup(true);
  localStorage.setItem('SelectedBookingId', dataId);
}

const handelOrderNo =(data)=>{
  setOrderNo(data.order_no);
  setupdateId(data.id);
  setCurrentOrder(data);
  console.log(orderNo +'---'+updateId)
}

const handleshowItems =(data)=>{
  setorderItems(data);
  setOrderedItempopup(true);
}

    return(
      <>         <Layout>

<div class="splitno">

<div style={{border:"none", padding:"15px", width:"100%", height:"650px",margin:"auto",borderRadius:"15px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px", marginTop:"-15px"}}>    
   <Row>
    <div className="d-flex justify-content-around align-items-center ">
    <h4 className='ushe'>CANCELLED ORDER REPORT</h4>  
        <div style={{ margin: 'auto',  display: 'flex',
    justifyContent: 'center' }}>
    
      <div
        className="search-filter-container"
        style={{
          borderRadius: '10px',
          backgroundColor: 'white',
        }}
      >
        <InputGroup className="mb-3" style={{ display: 'flex', alignItems: 'center',gap:"20px",marginTop:"10px" }}>
          {/* <Form.Control
            type="search"
            placeholder="Search for category, name, company, etc."
            style={{ borderRadius: '8px', marginRight: '10px' }}
          /> */}

          {/* Start Date Picker */}
          <div style={{ display: "flex", flexDirection: "row",gap:"40px",alignItems:'center' }}>
          <div style={{ display: "flex", flexDirection: "row",gap:"10px",alignItems:'center' }}>
                      <lable  className="form-label m-0">START DATE:</lable>
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => {
                          setStartDate(date);
                          if (endDate && date > endDate) {
                            setEndDate(null); // Reset end date if it's before the new start date
                          }
                        }}
                        placeholderText="Start Date"
                        className="form-control m-0"
                        style={{ marginRight: '10px', borderRadius: '8px' }}
                      />
                    </div>
                    {/* End Date Picker */}
                    <div style={{ display: "flex", flexDirection: "row" ,gap:"10px",alignItems:'center'}}>
                      <lable className="form-label  m-0">END DATE:</lable>

                      <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        placeholderText="End Date"
                        className="form-control m-0"
                        style={{ marginRight: '10px', borderRadius: '8px' }}
                        minDate={startDate}
                      />
                    </div>
                    </div>
          {/* Search Button */}
          {/* <div style={{display:"flex",flexDirection:"column"}}>
            <h6></h6>
            <Button variant='dark' className='mb-3' onClick={handleCreateEmployee}   style={{fontSize:"12px",borderRadius:"10px"}}>Search</Button>
            </div> */}
        </InputGroup>
      </div>
    </div>
    <DropdownButton
    variant="dark"
    title={
      <>
        <FaDownload style={{ marginRight: "5px" }} />
        Download
      </>
    }
    className="ms-3 m-0"
    style={{
      fontSize: "14px",
      borderRadius: "30px",
    }}
  >
    <Dropdown.Item onClick={downloadReport} >Download PDF</Dropdown.Item>
    <Dropdown.Item   onClick={downloadExcel}>Download Excel</Dropdown.Item>
  </DropdownButton>
        {/* <Button variant="primary" style={{ borderRadius: '8px' }} onClick={downloadReport}>
          <FaDownload style={{ marginRight: '5px' }} /> Download Report
        </Button> */}
      </div>
      </Row>
      <div className="d-flex justify-content-end">
  <input
    className="form-control"
    type="text"
    placeholder="Search"
    style={{ width: "20%" }}
    onChange={handleSearchInput}
  />
</div>

      <div className="table-container" style={{ height: '450px', overflowY: 'auto', marginTop: '10px' }}>
        <table className="table caption-top" style={{ borderColor: 'grey', width: '100%', margin: 'auto' }}>
          <thead>
          <tr style={{ fontWeight: 'bold' }}>
                  <th style={{ textAlign: 'left' }}>S.No</th>
                  <th style={{ textAlign: 'left' }}>Customer Name</th>
                  <th style={{ textAlign: 'left' }}>Mobile</th>
                  <th style={{ textAlign: 'left' }}>Order Id</th>
                  <th style={{ textAlign: 'left' }}>Order Address</th>
                  <th style={{ textAlign: 'left' }}>Order Type</th>
                  <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Delivery Date</th>
                  <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Rejected Date</th>
                  <th style={{ textAlign: 'left' }}>Amount</th>
                  <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Rejected Remarks</th>
                  <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Payment Status</th>
                  <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Refund Status</th>
                  <th style={{ textAlign: 'left' }}>view</th>
                </tr>
          </thead>
          {loading ? (
            <Loader/>
          ) : (
            <tbody
            >
            {currentItems.length > 0 ? (
              currentItems.map((order, index) => (
                <tr>
                  <th scope="row">{ indexOfFirstItem + index + 1}</th>
                  <td>{order.customer_name}</td>
                  <td>{order.mobile_no}</td>
                  <td style={{color:"blue" }}>{order.order_no}</td>
                  <td>{order.delivery_address}</td>
                  <td style={{ textTransform: "capitalize", textAlign: "left",  color: order.order_type === 1 ? "purple" :  order.order_type === 2 ? "orange"  : "grey", fontWeight: "bold" }}>
                    {order.order_type === 1 ? "Normal Order" : order.order_type === 2 ? "Credit Order" : "-"}
                  </td>
                  <td style={{ textTransform: "capitalize", textAlign: "left" }}>
                    {order.booking_dates?.date || "-"}
                  </td>
                  <td style={{ textTransform: "capitalize", textAlign: "left" }}>
                    {order.rejected_date || "-"}
                  </td>
                  <td style={{ textTransform: "capitalize", textAlign: "left" }}>
                    ${order.amount || "-"}
                  </td>
                  <td style={{ textTransform: "capitalize", textAlign: "left" }}>
                    {order.reject_remarks || "-"}
                  </td>

                  <td style={{
                    textAlign: "left",
                    color: order.payment_status === 0 ? "red" : "green",
                    fontWeight: "bold"
                  }}>
                    {order.payment_status === 0 ? "Not Paid" : "Paid"}

                  </td>
                  <td style={{ textTransform: "capitalize", textAlign: "left" }}>
                    {order.is_refund === 1 ? (
                      <span style={{ color: "green", fontSize: "15px", fontWeight: 'bold' }}>
                        Refunded
                      </span>
                    ) : (
                      <span style={{ color: "orange", fontSize: "15px", fontWeight: 'bold' }}>
                          Not Refunded
                      </span>
                    )}
                  </td>

                  <td>
          <div style={{ textAlign: "left", display: "flex", gap: "2px" }}>
            <button
              className="btn btn-primary"
              onClick={() => {
                handleshow(order.booking_dates,order.id);
                handelOrderNo(order);
              }}
                            style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              <i style={{ color: "white", fontSize: "13px" }} className="bi bi-eye-fill"></i>
            </button>
            </div>
            </td>


                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="16" style={{ textAlign: "center", color: "red", fontWeight: "bold", borderColor: "black" }}>
                  No Cancelled Orders Found
                </td>
              </tr>
            )}
          </tbody>
          )}
        </table>
      </div>
      <Pagination
              activePage={currentPage}
              itemsCountPerPage={itemsPerPage}
              totalItemsCount={totalItems}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
              itemClass="page-item"
              linkClass="page-link"
              innerClass="pagination justify-content-end mt-4"
              activeClass="active-pagination"
            />
    </div>
    <Modal
  show={itempopup}
  onHide={() => setItempopup(false)}
  backdrop="static"
  keyboard={false}
  size="xl"
>
  <Modal.Header closeButton>
    {/* <Modal.Title>Delivery Dates (Order No - {orderNo})</Modal.Title> */}
    <Modal.Title>Delivery Dates</Modal.Title>
  </Modal.Header>
  <Modal.Body>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin:"15px 30px"}}>
  <h5>
    Order Id: <span style={{fontSize:"22px", color: "blue"}}>{currentOrder.order_no}</span>
  </h5>
  <h5 >
    Customer Name: <span style={{fontSize:"20px", color: "blue"}}>{currentOrder.customer_name}</span>
  </h5>
  <h5>
    Customer Mobile: <span style={{fontSize:"20px", color: "blue"}}>{currentOrder.mobile_no}</span>
  </h5>
</div>

    {/* Bill-Like List Design */}
    <Table hover style={{ marginBottom: "20px" }}>
      <thead>
        <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold", color: "green" }}>
        <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Delivery Date</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Slot Name</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">From Time</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">To Time</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Delivery Person</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Status</th>

          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">View List</th>


        </tr>
      </thead>
      <tbody >
  {bookingOrder.length > 0 ? (
        (() => {
          let serialCounter = 1; // Initialize counter for Serial No
          return bookingOrder.map((dateItem, dateIndex) =>
      dateItem.slots.length > 0 ? (
        dateItem.slots.map((slot, slotIndex) => (
          <tr key={`${dateIndex}-${slotIndex}`} style={{borderBottom:"0.5px solid black"}}>
       
            <td>{serialCounter++}</td>
            <td>{dateItem.date}</td>
            <td>{slot.slot_name}</td>
            <td>{slot.from_time}</td>
            <td>{slot.to_time}</td>
            <td
 style={{
  textAlign: "center",
  display: "flex",
  borderTop: "none",
  borderBottom: "none",
  alignItems:'center',

  gap: "20px",
  alignContent: "center",
  // marginTop: "11px",
  height: "100px",
}}
>
  {slot.slot_delivery_person_name ? (
    <>
      {slot.slot_delivery_person_profile && (
        <img
          src={profile}
          alt="profile"
          style={{
            width: "30px",
            height: "30px",
            objectFit: "cover",
            borderRadius: "50%",
          }}
        />
      )}
      {slot.slot_delivery_person_name}
    </>
  ) : (
    "-"
  )}
</td>
            <td style={{
          textAlign: "left",
          color: slot.slot_status === 0 ? "blue" :
          slot.slot_status === 1 ? "orange" :
          slot.slot_status === 2 ? "green" :
          slot.slot_status === 3 ? "red" : "gray",
          fontWeight: "bold",
        }}>
          {slot.slot_status === 0 ? "New" :
           slot.slot_status === 1 ? "Inprogress" :
           slot.slot_status === 2 ? "Packed" :
           slot.slot_status === 3 ? "Delivered" : "Cancelled"}
        </td>
            <td>
              <button className="btn btn-primary" onClick={() => handleshowItems(slot.order_items)}>
                <i style={{ color: "white", fontSize: "13px" }} className="bi bi-eye-fill"></i>
              </button>
            </td>

          </tr>
        ))
      ) : (
        <tr key={dateIndex}>
          <td colSpan="6" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
            No data available
          </td>
        </tr>
      )
    );
  })()
  ) : (
    <tr>
      <td colSpan="10" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
        No data available
      </td>
    </tr>
  )}
</tbody>

    </Table>
    {/* <button
      className="btn btn-danger"
      onClick={() => setItempopup(false)}
      style={{ borderRadius: "15px", float: "right", marginTop: "-1px" }}
    >
      Cancel
    </button> */}
  </Modal.Body>
</Modal>

<Modal
  show={setOrdereditempopup}
  onHide={() => setOrderedItempopup(false)}
  backdrop="dynamic"
  keyboard={false}
  size="xl"
  fullscreen="sm-down" // Makes it responsive for small devices
  style={{ bottom: "0", marginTop: "auto" }} // Adjusts position
>
  <Modal.Header closeButton>
    <Modal.Title>Items</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Table hover style={{ marginBottom: "20px" }}>
      <thead>
        <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold", color: "green" }}>
          <th>S.No</th>
          <th>Image</th>
          <th>Food Name</th>
          <th>Item Code</th>
          <th>Quantity</th>
          <th>Unit Price</th>
          <th>Variant Name</th>
          <th>Remarks</th>
          <th>Additional Notes</th>
        </tr>
      </thead>
      <tbody>
        {orderedItems.length > 0 ? (
          orderedItems.map((item, index) => (
            <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
              <td>{index + 1}</td>
              <td>
                <img
                  src={`${image_api}/${item.food_image}`}
                  alt="item_image"
                  width="50px"
                  height="50px"
                />
              </td>
              <td>{item.food_name}</td>
              <td>{item.item_code}</td>
              <td>{item.quantity}</td>
              <td>{item.unit_price}</td>
              <td>{item.variant_name}</td>
              <td>{item.remark}</td>
              <td>
  <div className="notes-cell" title={item.additional_notes}>
    {item.additional_notes}
  </div>
  </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="8" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
              No data available
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </Modal.Body>
</Modal>
    </div>
   


            {/* </div> */}
       </Layout></>

        
    )
}

export default NewOrder;